export default {
  'inventory.tab.platform_inventory': 'Platform Inventory',
  'inventory.tab.platform_inventory_tooltips': 'Platform Inventory',
  'inventory.tab.interface_inventory': 'Inventory (SAP Feedback)',
  'inventory.tab.interface_inventory_tooltips': 'Inventory (SAP Feedback)',
  'inventory.tab.morellato_inventory': 'Morellato Inventory',
  'inventory.tab.morellato_inventory_tooltips': 'Morellato Inventory',
  "inventories.on_hand_stock": "Total Qty",
  "inventories.can_order_stock": "Available Qty",
  "inventories.ordered_stock": "Handle Qty",
  "inventories.picking_stock": "Picking Qty",
  "inventories.picked_stock": "Packed Qty",
  'inventories.sap_date_at': 'SAP Date At',
  'inventories.full_synced_date_at': 'Full Synced At',
  'inventories.synced_date_at': 'Synced At',
  "inventories.interface.qty": "Qty",
  "inventories.interface.date": "Date",
  "inventories.interface.error": "Error",
  "inventories.interface.status": "Status",
  'inventories.update_available_qty': 'New Available Qty',
  'inventories.remark': 'Remark',
  'inventories.button.sync-stock-to-platform': 'Sync To Platform',
  'inventories.request.sync-stock-to-platform-confirm': 'Are you sure to sync this SKU {sku} to external platform {platform}?',
  'inventories.action-msg.sync-stock-to-platform-success': 'Sync platform stock successful',
  'inventories.button.edit-morellato-stock-sync': 'Edit Stock',
  'inventories.request.edit-morellato-stock-sync-confirm': 'Are you sure to update this SKU {sku} and sync to all platforms stock?',
  'inventories.action-msg.update-morellato-stock-to-sync-success': 'Update Morellato stock successful',
  'inventories.button.sync-platform-product': 'Sync Platform Product',
  'inventories.sync-platform-product-confirm': 'Are you sure to sync the SKU {sku} for all platforms?',
  'inventories.action-msg.sync-platform-product-success': 'Sync Platform Product Success',
};
